(() => {
  if (window.MayLondonNavigation) return;
  window.MayLondonNavigation = true;
  const timers = new Map();
  const header = document.querySelector('[data-storefront-header]');
  if (header) {
    const updateHeaderHeight = () => document.documentElement.style.setProperty('--mobile-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    updateHeaderHeight();
    if ('ResizeObserver' in window) new ResizeObserver(updateHeaderHeight).observe(header);
  }
  function init(scope = document) {
    scope.querySelectorAll('.announcement__track').forEach((track) => {
      if (timers.has(track)) return;
      const items = [...track.querySelectorAll('.announcement__item')];
      if (!items.length) return;
      track.classList.add('is-initialized');
      items.forEach((item, index) => { item.hidden = index !== 0; item.classList.toggle('is-visible', index === 0); });
      let index = 0;
      const timer = setInterval(() => {
        if (document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        items[index].classList.remove('is-visible'); items[index].hidden = true;
        index = (index + 1) % items.length;
        items[index].hidden = false; items[index].classList.add('is-visible');
      }, 7000);
      timers.set(track, timer);
    });
  }
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.site-header details[open]').forEach((details) => { if (!details.closest('[data-mobile-menu]') && !details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => timers.forEach((timer, track) => { if (event.target.contains(track)) { clearInterval(timer); timers.delete(track); } }));
  init();
})();
